import { render, staticRenderFns } from "./InvoiceCarrierList.vue?vue&type=template&id=527f5b9c&"
import script from "./InvoiceCarrierList.vue?vue&type=script&lang=js&"
export * from "./InvoiceCarrierList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCarrierList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports